import { iframeDataBridge } from '@/iframe/iframeDataBridge';
import { authenticatedFetch, getApiUrl } from '@/utils/auth/authService';
import { log } from '@/utils/core/vueLogger.js';
import { CacheManager } from '@/utils/core/cacheManager.js';

const organisationSharingCache = new CacheManager('VueCache', 'cache', {
    maxAge: 24 * 60 * 60 * 1000,
    memoryCacheTTL: 30 * 60 * 1000,
    logCategory: 'OrganisationSharing',
    keyPrefix: () => `${iframeDataBridge.getCustomer() ?? 'unknown'}.${iframeDataBridge.getCurrentUser()?.id ?? 'unknown'}.organisationSharings.`,
});

export async function getOrganisationSharings(forceRefresh = false) {
    if (!forceRefresh && !organisationSharingCache.getFromMemory('all')) {
        try {
            const legacyData = await iframeDataBridge.getStorageAsync('ORGANISATIONS_SHARING');
            if (legacyData) {
                log('info', 'OrganisationSharing', '📦 Seeding Vue cache from legacy storage (ORGANISATIONS_SHARING)');
                await organisationSharingCache.put('all', legacyData);
                organisationSharingCache.setInMemory('all', legacyData);
                return legacyData;
            }
        } catch (legacyError) {
            log('warn', 'OrganisationSharing', `⚠️ Legacy storage check failed: ${legacyError.message}`);
        }
    }

    return organisationSharingCache.fetchOrCache('all', fetchOrganisationSharingsFromAPI, { forceRefresh, fallback: [], backgroundRefresh: true });
}

async function fetchOrganisationSharingsFromAPI() {
    const response = await authenticatedFetch(getApiUrl('Core/OrganisationSharings'), { method: 'GET' }, 'token');

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const organisationSharings = await response.json();
    log('success', 'OrganisationSharing', `✅ Fetched ${organisationSharings.length} organisation sharings`);
    return organisationSharings;
}

export async function refreshOrganisationSharings() {
    organisationSharingCache.clearMemory();
    await organisationSharingCache.clear();
}
